import { useAuthHeaders } from '%hooks/auth';
import { ImageWithBlurhash, ImageWithBlurhashProps } from '%components/ImageWithBlurhash';
import { MediaVideo, MediaVideoProps } from './MediaVideo';

export const Media = ({ source, ...props }: MediaProps) => {
	const { getHeaders } = useAuthHeaders();
	const { type, ...mediaSource } = source;

	const sourceWithAuth = {
		...mediaSource,
		headers: getHeaders(source.uri),
	};

	if (type === 'video') {
		return <MediaVideo source={sourceWithAuth} style={props.style} {...props.videoProps} />;
	}

	if (type === 'image') {
		return <ImageWithBlurhash source={sourceWithAuth} style={props.style} {...props.imageProps} />;
	}

	return null;
};

export type MediaProps =
	| {
			source: { type: 'image' } & ImageWithBlurhashProps['source'];
			style: ImageWithBlurhashProps['style'];
			imageProps: Omit<ImageWithBlurhashProps, 'source' | 'style'>;
	  }
	| {
			source: { type: 'video' } & MediaVideoProps['source'];
			style: MediaVideoProps['style'];
			videoProps?: Omit<MediaVideoProps, 'source' | 'style'>;
	  };
